import { render } from "./contextPage.vue?vue&type=template&id=397d8db8"
import script from "./contextPage.vue?vue&type=script&lang=js"
export * from "./contextPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__